// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RegistrationPage_wrapper__2aSYl","header":"RegistrationPage_header__20Qu_","signIn":"RegistrationPage_signIn__1CiqW"};